var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 50,
    viewBox: "0 0 82 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9939 14.1468L22.8291 35.9113H16.85L12.3421 18.5435C12.0666 17.4726 11.8301 17.0823 10.9972 16.6306C9.63931 15.8984 7.39348 15.2081 5.41663 14.779L5.55274 14.1468H15.1777C16.4027 14.1468 17.5078 14.9597 17.7865 16.3661L20.1685 28.9629L26.0537 14.1468H31.9939ZM55.4245 28.8081C55.4472 23.0629 47.4426 22.7468 47.4976 20.1823C47.5138 19.4016 48.2625 18.5726 49.8958 18.3597C50.706 18.2532 52.9388 18.1726 55.4731 19.3339L56.4648 14.7177C55.1069 14.2242 53.3537 13.75 51.1759 13.75C45.5856 13.75 41.6513 16.7081 41.6157 20.9468C41.58 24.079 44.4254 25.8274 46.5676 26.8694C48.7713 27.9371 49.5101 28.621 49.5004 29.5726C49.4875 31.0339 47.7439 31.6758 46.1171 31.7016C43.2717 31.7468 41.6222 30.9371 40.3064 30.3274L39.2824 35.0952C40.6046 35.6984 43.0416 36.2242 45.5726 36.25C51.5162 36.2532 55.405 33.3306 55.4245 28.8081ZM70.1861 35.9113H75.4166L70.8504 14.1468H66.0217C64.9361 14.1468 64.0222 14.7758 63.6138 15.7435L55.1296 35.9113H61.0699L62.2495 32.6597H69.5055L70.1861 35.9113ZM63.8731 28.2016L66.8513 20.0274L68.5657 28.2016H63.8731ZM40.0763 14.1468L35.4 35.9113H29.7416L34.4213 14.1468H40.0763Z",
    fill: "#1A1F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6241ee189a35f8d847595d7d06de1d8d.svg";
export { ForwardRef as ReactComponent };